export function updateAdResourceStatusForFilter({ entitySchema, i18n, IsGoogleImportVideoAdsEnabled }) {
  const adResourceStatusSchema = entitySchema.properties.AdResourceStatusId;

  if (IsGoogleImportVideoAdsEnabled) {
    adResourceStatusSchema.chooseType = 'select';
    adResourceStatusSchema.operators = ['eq'];
    adResourceStatusSchema.title = i18n && i18n.getString('Schema_Ad_Property_AdResourceStatusId');
    adResourceStatusSchema.enum = ["Enum.AdResourceStatus'Invalid'", "Enum.AdResourceStatus'Valid'", "Enum.AdResourceStatus'Pending'", "Enum.AdResourceStatus'GoogleImportedVideoNeedRepair'"];
    adResourceStatusSchema.enumValueMap = {
      "Enum.AdResourceStatus'Invalid'": 'Invalid',
      "Enum.AdResourceStatus'Valid'": 'Valid',
      "Enum.AdResourceStatus'Pending'": 'Pending',
      "Enum.AdResourceStatus'GoogleImportedVideoNeedRepair'": 'Online Video ad campaigns require videos to serve',
    };
  } else {
    adResourceStatusSchema.filterable = false;
  }
}
